<template>
    <div class="relative z-0 min-h-full overflow-hidden bg-blue-bg text-grey-darkest">
        <div
            :class="{ 'has-sidebar-open': is_sidebar_open }"
            class="dashboard"
        >
            <nav class="overflow-y-auto text-white sidebar scrollbar-hidden bg-grey-darker id-sidebar">
                <on-escape :execute="close">
                    <div class="flex flex-col min-h-full">
                        <div class="flex-grow">
                            <div class="relative items-center hidden h-16 text-center lg:flex">
                                <laroute-link
                                    :to="{ name: 'www.home.index' }"
                                    class="block h-5 mx-auto text-white"
                                >
                                    <base-svg
                                        name="logo-rentora"
                                        class="h-full fill-primary-white"
                                    />
                                </laroute-link>

                                <div class="absolute bottom-0 w-full h-px bg-grey-darker-10pcl" />
                            </div>

                            <div class="id-sidebar-links">
                                <ul class="mt-4 mb-4 lg:hidden">
                                    <li>
                                        <router-link
                                            :to="{ name: $router.fix('dashboard.*.settings.index') }"
                                            class="flex items-center sidebar-link"
                                        >
                                            <base-svg
                                                name="icon-user-circle"
                                                class="w-6 h-6 mr-3"
                                            />
                                            <landlords-current>
                                                <tenants-current slot-scope="{ data: landlord }">
                                                    <with-variables
                                                        slot-scope="{ data: tenant }"
                                                        :variables="{ data: landlord || tenant }"
                                                    >
                                                        <div
                                                            slot-scope="{ data: persona }"
                                                            class="leading-tight"
                                                        >
                                                            {{ persona.name }}

                                                            <div class="text-2xs text-grey text-label">
                                                                {{ persona.object }}
                                                            </div>
                                                        </div>
                                                    </with-variables>
                                                </tenants-current>
                                            </landlords-current>
                                        </router-link>
                                    </li>
                                </ul>

                                <ul class="mt-4 mb-4">
                                    <landlords-current v-slot="{ data: landlord }">
                                        <li
                                            v-if="$gate.role('landlord') && landlord.account.status !== landlord.account.consts.status.verified"
                                        >
                                            <router-link
                                                :to="{ name: $router.fix('dashboard.*.verification.edit') }"
                                                class="flex items-center sidebar-link"
                                                active-class="is-active"
                                            >
                                                <base-svg
                                                    name="icon-security-check"
                                                    class="w-6 h-6 mr-3"
                                                />
                                                Verify Account
                                            </router-link>
                                        </li>
                                    </landlords-current>
                                    <li>
                                        <router-link
                                            :to="{ name: $router.fix('dashboard.*.overview.index') }"
                                            class="sidebar-link"
                                            active-class="is-active"
                                        >
                                            <div class="flex items-center">
                                                <base-svg
                                                    name="icon-tune"
                                                    class="w-6 h-6 mr-3"
                                                />
                                                Overview
                                            </div>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link
                                            :to="{ name: $router.fix('dashboard.*.chats.index') }"
                                            class="flex items-center sidebar-link"
                                            active-class="is-active"
                                        >
                                            <base-svg
                                                name="icon-chat"
                                                class="w-6 h-6 mr-3"
                                            />
                                            Messages
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link
                                            :to="{ name: $router.fix('dashboard.*.tasks.index') }"
                                            class="flex items-center sidebar-link"
                                            active-class="is-active"
                                        >
                                            <base-svg
                                                name="icon-check-square"
                                                class="w-6 h-6 mr-3"
                                            />
                                            Tasks
                                        </router-link>
                                    </li>
                                </ul>

                                <ul class="mt-4 mb-4">
                                    <li>
                                        <router-link
                                            :to="{
                                                name: $gate.role('landlord')
                                                    ? 'dashboard.landlords.transactions.index'
                                                    : 'dashboard.tenants.charges.index'
                                            }"
                                            class="flex items-center sidebar-link"
                                            active-class="is-active"
                                        >
                                            <base-svg
                                                name="icon-money"
                                                class="w-6 h-6 mr-3"
                                            />
                                            Payments
                                        </router-link>
                                    </li>
                                </ul>

                                <ul class="mt-4 mb-4">
                                    <li v-if="$gate.role('landlord')">
                                        <router-link
                                            :to="{ name: $router.fix('dashboard.*.properties.index') }"
                                            class="flex items-center sidebar-link id-sidebar-properties"
                                            active-class="is-active"
                                        >
                                            <base-svg
                                                name="icon-home"
                                                class="w-6 h-6 mr-3"
                                            />
                                            Properties
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link
                                            :to="{ name: $router.fix('dashboard.*.tenancies.index') }"
                                            class="flex items-center sidebar-link"
                                            active-class="is-active"
                                        >
                                            <base-svg
                                                name="icon-key"
                                                class="w-6 h-6 mr-3"
                                            />
                                            Tenancies
                                        </router-link>
                                    </li>
                                    <li v-if="$gate.role('landlord')">
                                        <router-link
                                            :to="{ name: $router.fix('dashboard.*.tenants.index') }"
                                            class="flex items-center sidebar-link"
                                            active-class="is-active"
                                        >
                                            <base-svg
                                                name="icon-user-group"
                                                class="w-6 h-6 mr-3"
                                            />
                                            Tenants
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link
                                            :to="{ name: $router.fix('dashboard.*.rents.index') }"
                                            class="flex items-center sidebar-link"
                                            active-class="is-active"
                                        >
                                            <base-svg
                                                name="icon-collection"
                                                class="w-6 h-6 mr-3"
                                            />
                                            Rents
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link
                                            :to="{ name: $router.fix('dashboard.*.fees.index') }"
                                            class="flex items-center sidebar-link"
                                            active-class="is-active"
                                        >
                                            <base-svg
                                                name="icon-receipt"
                                                class="w-6 h-6 mr-3"
                                            />
                                            Fees
                                        </router-link>
                                    </li>
                                </ul>

                                <ul class="mt-4 mb-4">
                                    <li v-if="$gate.role('landlord')">
                                        <router-link
                                                :to="{ name: $router.fix('dashboard.*.listings.index') }"
                                                class="flex items-center sidebar-link"
                                                active-class="is-active"
                                        >
                                            <base-svg
                                                    name="icon-listing"
                                                    class="w-6 h-6 mr-3"
                                            />
                                            Listings
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link
                                                :to="{ name: $router.fix('dashboard.*.applications.index') }"
                                                class="flex items-center sidebar-link"
                                                active-class="is-active"
                                        >
                                            <base-svg
                                                    name="icon-inbox"
                                                    class="w-6 h-6 mr-3"
                                            />
                                            Applications
                                        </router-link>
                                    </li>
                                </ul>

                                <ul v-if="$gate.role('landlord') && $_.preload('app.beta.is-enrolled')">
                                    <li>
                                        <router-link
                                            :to="{
                                                name: $router.fix('dashboard.*.contacts.index')
                                            }"
                                            class="flex items-center sidebar-link"
                                            active-class="is-active"
                                        >
                                            <base-svg
                                                name="icon-identification"
                                                class="w-6 h-6 mr-3"
                                            />
                                            Contacts
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link
                                            :to="{
                                                name: $router.fix('dashboard.*.maintenances.index')
                                            }"
                                            class="flex items-center sidebar-link"
                                            active-class="is-active"
                                        >
                                            <base-svg
                                                name="icon-work"
                                                class="w-6 h-6 mr-3"
                                            />
                                            Maintenance
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="flex-none pt-6">
                            <ul class="py-6 lg:hidden">
                                <li>
                                    <router-link
                                        :to="{ name: $router.fix('dashboard.*.notifications.index') }"
                                        class="flex items-center sidebar-link"
                                    >
                                        <base-svg
                                            name="icon-notification"
                                            class="w-6 h-6 mr-3"
                                        />
                                        Notifications
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        :to="{ name: $router.fix('dashboard.*.settings.index') }"
                                        class="flex items-center sidebar-link"
                                    >
                                        <base-svg
                                            name="icon-cog"
                                            class="w-6 h-6 mr-3"
                                        />
                                        Settings
                                    </router-link>
                                </li>
                            </ul>

                            <div class="w-full h-px bg-grey-darker-10pcl" />

                            <ul class="py-6">
                                <li>
                                    <laroute-link
                                        :to="{ name: 'auth.sessions.destroy' }"
                                        class="flex items-center sidebar-link"
                                    >
                                        <base-svg
                                            name="icon-door-exit"
                                            class="w-6 h-6 mr-3"
                                        />
                                        Logout
                                    </laroute-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </on-escape>
            </nav>

            <div class="relative w-full overflow-y-scroll scrolls-to-top">
                <div class="relative inset-x-0 top-0 z-10 h-16 lg:sticky bg-blue-bg lg:border-b lg:border-blue-bg-dark">
                    <div class="absolute inset-x-0 top-0 bg-blue h-1-5" />

                    <div class="container h-full max-w-xl ml-0 pt-1-5 md:px-6 xl:px-12">
                        <div class="flex items-center h-full">
                            <div class="flex-none w-6 h-6 mr-3 md:mr-6 lg:hidden">
                                <button
                                    class="block w-full h-full focus:outline-none id-sidebar-menu"
                                    @click.prevent="is_search_open ? is_search_open = false : is_sidebar_open = true"
                                >
                                    <base-svg
                                        :key="is_sidebar_open || is_search_open ? 'icon-close' : 'icon-menu'"
                                        :name="is_sidebar_open || is_search_open ? 'icon-close' : 'icon-menu'"
                                        class="w-full h-full fill-current"
                                    />
                                </button>
                            </div>

                            <div
                                v-if=" ! is_search_open"
                                key="logo"
                                class="flex-grow h-6 text-center md:text-left lg:hidden"
                            >
                                <laroute-link
                                    :to="{ name: 'www.home.index' }"
                                    class="inline-block h-5"
                                >
                                    <base-svg
                                        name="logo-rentora"
                                        class="h-full fill-primary-blue"
                                    />
                                </laroute-link>
                            </div>

                            <div
                                :class="is_search_open ? 'flex-grow' : 'flex-none'"
                                class="text-right md:w-5/12 lg:flex-grow"
                            >
                                <div
                                    :class="{
                                        'hidden': ! is_search_open,
                                    }"
                                    class="relative md:block lg:max-w-xs"
                                >
                                    <the-layout-dashboard-search />
                                </div>

                                <button
                                    :class="{
                                        'hidden': is_search_open,
                                    }"
                                    class="block w-6 h-6 mr-3 md:hidden focus:outline-none"
                                    @click.prevent="is_search_open = true"
                                >
                                    <base-svg
                                        name="icon-search"
                                        class="w-full h-full fill-current"
                                    />
                                </button>
                            </div>

                            <div class="flex-none hidden lg:block">
                                <div class="flex items-center">
                                    <router-link
                                        v-if="false"
                                        :to="{ path: '#' }"
                                        class="w-6 h-6 mr-3"
                                    >
                                        <base-svg
                                            name="icon-announcement"
                                            class="w-full h-full"
                                        />
                                    </router-link>

                                    <router-link
                                        :to="{ name: $router.fix('dashboard.*.notifications.index') }"
                                        class="w-6 h-6 mr-3"
                                    >
                                        <base-svg
                                            name="icon-notification"
                                            class="w-full h-full"
                                        />
                                    </router-link>

                                    <router-link
                                        :to="{ name: $router.fix('dashboard.*.settings.index') }"
                                        class="w-6 h-6 mr-3"
                                    >
                                        <base-svg
                                            name="icon-cog"
                                            class="w-full h-full"
                                        />
                                    </router-link>

                                    <div class="w-px h-8 mr-3 bg-blue-bg-dark" />

                                    <the-layout-dashboard-account-landlord v-if="$gate.role('landlord')" />

                                    <the-layout-dashboard-account-tenant v-if="$gate.role('tenant')" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="absolute inset-0 pt-16">
                    <div class="container relative h-full max-w-xl px-3 pb-3 md:px-6 md:pb-6 lg:pt-3 xl:px-12">
                        <router-view />
                    </div>
                </div>
            </div>

            <div
                class="z-30 dashboard-overlay"
                @click.prevent="is_sidebar_open = false"
            />
        </div>
    </div>
</template>

<script>
    import HeadMixin from '../mixins/head'
    import LandlordsCurrent from './landlords-current'
    import TenantsCurrent from './tenants-current'
    import TheLayoutDashboardAccountLandlord from './the-layout-dashboard-account-landlord'
    import TheLayoutDashboardAccountTenant from './the-layout-dashboard-account-tenant'
    import TheLayoutDashboardSearch from './the-layout-dashboard-search'

    export default {
        mixins: [
            HeadMixin
        ],
        components: {
            LandlordsCurrent,
            TenantsCurrent,
            TheLayoutDashboardAccountLandlord,
            TheLayoutDashboardAccountTenant,
            TheLayoutDashboardSearch
        },
        data () {
            return {
                is_sidebar_open: false,
                is_search_open: false
            }
        },
        watch: {
            '$route' () {
                this.close()
            },
            is_sidebar_open () {
                this.$eventBus.$emit(
                    'the-layout-dashboard:is_sidebar_open',
                    this.is_sidebar_open
                )
            }
        },
        created () {
            this.$eventBus.$on('the-layout-dashboard@open', this.open)
        },
        methods: {
            open () {
                this.is_sidebar_open = true
                this.is_search_open = false
            },
            close () {
                this.is_sidebar_open = false
                this.is_search_open = false
            },
            head () {
                return {
                    title: 'Dashboard'
                }
            }
        }
    }
</script>
